import * as types from "../types/foodPageSidebarRef"

const initialState = null

const foodPageSidebarRefReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.ADD_FOOD_PAGE_SIDEBAR_REF:
      return action.ref
    case types.FOOD_SIDEBAR_SCROLL_TO_BUTTOM:

      setTimeout(() => {
        !!state?.scrollTo &&
          state.scrollTo({ left: 0, top: 1000000, behavior: "smooth" })
      }, 100)

      return state
    default:
      return state
  }
}

export default foodPageSidebarRefReducer